(() => {
  const root = document.querySelector('[data-ib-recipe]');
  if (!root) return;

  const saveButton = root.querySelector('[data-save-recipe]');
  const shareButton = root.querySelector('[data-share-recipe]');
  const updateButton = root.querySelector('[data-update-recipe]');

  const getAbsoluteUrl = (url) => {
    if (!url) return '';

    try {
      return new URL(url, window.location.origin).href;
    } catch (error) {
      return '';
    }
  };

  const getRecipeTitle = () => {
    return (
      shareButton?.dataset.shareTitle?.trim() ||
      root.querySelector('.ib-recipe-hero h1')?.textContent?.trim() ||
      document.title ||
      'InnerBuddies recipe'
    );
  };

  const getRecipeUrl = () => {
    return window.location.href.split('#')[0];
  };

  const getRecipeImage = () => {
    const imageFromButton = shareButton?.dataset.shareImage;
    const imageFromDataAttribute = root.querySelector('[data-recipe-image]')?.getAttribute('src');
    const imageFromHero = root.querySelector('.ib-recipe-hero-image img')?.getAttribute('src');
    const imageFromOg = document.querySelector('meta[property="og:image"]')?.getAttribute('content');

    const imageUrl = getAbsoluteUrl(
      imageFromButton ||
      imageFromDataAttribute ||
      imageFromHero ||
      imageFromOg
    );

    if (
      !imageUrl ||
      imageUrl.includes('Liquid%20error') ||
      imageUrl.includes('Liquid error')
    ) {
      return '';
    }

    return imageUrl;
  };

  const getShareText = () => {
    return `Check out this recipe: ${getRecipeTitle()}`;
  };

/*
  SAVE RECIPE
*/
if (saveButton) {
  const n8nWebhookUrl = 'https://n8n.genzai.dev/webhook/save-recipes';

  const recipeId = saveButton.dataset.recipeId;
  const customerId = saveButton.dataset.customerId;
  const loginUrl = saveButton.dataset.loginUrl || '/account/login';

  const icon = saveButton.querySelector('[data-save-icon]');
  const label = saveButton.querySelector('[data-save-label]');
  const status = saveButton.querySelector('[data-save-status]');

  const setButtonState = ({ saved, loading = false, message = '' }) => {
    saveButton.dataset.saved = saved ? 'true' : 'false';
    saveButton.classList.toggle('is-saved', saved);
    saveButton.classList.toggle('is-loading', loading);
    saveButton.disabled = loading;

    if (icon) icon.textContent = saved ? '♥' : '♡';
    if (label) label.textContent = saved ? 'Saved recipe' : 'Save recipe';
    if (status && message) status.textContent = message;
  };

  saveButton.addEventListener('click', async (event) => {
    event.preventDefault();

    if (!customerId) {
      window.location.href = `${loginUrl}?return_url=${encodeURIComponent(window.location.pathname)}`;
      return;
    }

    if (!recipeId) {
      setButtonState({
        saved: false,
        loading: false,
        message: 'Recipe could not be saved.'
      });
      return;
    }

    const currentlySaved = saveButton.dataset.saved === 'true';
    const nextSaved = !currentlySaved;

    setButtonState({
      saved: currentlySaved,
      loading: true,
      message: nextSaved ? 'Saving...' : 'Removing...'
    });

    try {
      const response = await fetch(n8nWebhookUrl, {
        method: 'POST',
        headers: {
          /*
            Use text/plain to avoid CORS preflight issues in many n8n setups.
            n8n can still parse this as JSON in a Code node.
          */
          'Content-Type': 'text/plain'
        },
        body: JSON.stringify({
          customer_id: customerId,
          recipe_id: recipeId,
          action: nextSaved ? 'save' : 'remove',
          page_url: window.location.href
        })
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.error || 'Save failed');
      }

      setButtonState({
        saved: data.saved,
        loading: false,
        message: data.saved ? 'Saved to your favourites' : 'Removed from your favourites'
      });
    } catch (error) {
      setButtonState({
        saved: currentlySaved,
        loading: false,
        message: 'Something went wrong. Please try again.'
      });
    }
  });
}

  /*
    SHARE RECIPE
    WhatsApp/Facebook/LinkedIn use the recipe URL.
    The image preview should come from the page's og:image metadata.
    Pinterest receives the image separately as media.
  */
  if (shareButton) {
    const removeExistingShareMenu = () => {
      document.querySelectorAll('.ib-share-menu').forEach((menu) => {
        menu.remove();
      });
    };

    const createShareMenu = () => {
      const existingMenu = document.querySelector('.ib-share-menu');

      if (existingMenu) {
        existingMenu.remove();
        return;
      }

      const recipeTitle = getRecipeTitle();
      const recipeUrl = getRecipeUrl();
      const recipeImage = getRecipeImage();
      const shareText = getShareText();

      const encodedTitle = encodeURIComponent(recipeTitle);
      const encodedUrl = encodeURIComponent(recipeUrl);
      const encodedImage = encodeURIComponent(recipeImage);
      const encodedText = encodeURIComponent(shareText);

      const shareLinks = [
        {
          label: 'WhatsApp',
          url: `https://wa.me/?text=${encodedText}%0A%0A${encodedUrl}`
        },
        {
          label: 'Email',
          url: `mailto:?subject=${encodedTitle}&body=${encodedText}%0A%0A${encodedUrl}`
        },
        {
          label: 'Facebook',
          url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`
        },
        {
          label: 'X / Twitter',
          url: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`
        },
        {
          label: 'LinkedIn',
          url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`
        },
        {
          label: 'Pinterest',
          url: recipeImage
            ? `https://pinterest.com/pin/create/button/?url=${encodedUrl}&media=${encodedImage}&description=${encodedText}`
            : `https://pinterest.com/pin/create/button/?url=${encodedUrl}&description=${encodedText}`
        }
      ];

      const menu = document.createElement('div');
      menu.className = 'ib-share-menu';
      menu.setAttribute('role', 'menu');

      shareLinks.forEach((item) => {
        const link = document.createElement('a');
        link.href = item.url;
        link.textContent = item.label;
        link.target = item.label === 'Email' ? '_self' : '_blank';
        link.rel = 'noopener noreferrer';
        link.setAttribute('role', 'menuitem');

        menu.appendChild(link);
      });

      const copyButton = document.createElement('button');
      copyButton.type = 'button';
      copyButton.textContent = 'Copy recipe link';
      copyButton.setAttribute('role', 'menuitem');

      copyButton.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(recipeUrl);
          copyButton.textContent = '✓ Link copied';

          setTimeout(() => {
            removeExistingShareMenu();
          }, 1200);
        } catch (error) {
          window.prompt('Copy this recipe link:', recipeUrl);
        }
      });

      menu.appendChild(copyButton);

      shareButton.insertAdjacentElement('afterend', menu);
    };

    shareButton.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const recipeTitle = getRecipeTitle();
      const recipeUrl = getRecipeUrl();
      const shareText = getShareText();

      /*
        Native share:
        Do not include image URL in text.
        WhatsApp should use the recipe page URL and its og:image preview.
      */
      if (navigator.share) {
        try {
          await navigator.share({
            title: recipeTitle,
            text: shareText,
            url: recipeUrl
          });
          return;
        } catch (error) {
          if (error && error.name === 'AbortError') return;
        }
      }

      createShareMenu();
    });

    document.addEventListener('click', (event) => {
      const menu = document.querySelector('.ib-share-menu');

      if (
        menu &&
        !menu.contains(event.target) &&
        !shareButton.contains(event.target)
      ) {
        menu.remove();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        removeExistingShareMenu();
      }
    });
  }

  /*
    UPDATE RECIPE
  */
  if (updateButton) {
    updateButton.addEventListener('click', () => {
      const activeOptions = [...root.querySelectorAll('[data-recipe-adapt]:checked')]
        .map((input) => input.closest('label')?.querySelector('span')?.textContent?.trim())
        .filter(Boolean);

      updateButton.textContent = activeOptions.length
        ? `Updated for ${activeOptions.length} preference${activeOptions.length > 1 ? 's' : ''}`
        : 'Update recipe';

      setTimeout(() => {
        updateButton.textContent = 'Update recipe';
      }, 1800);
    });
  }

  /*
    AI SUGGESTIONS
  */
  root.querySelectorAll('.ib-ai-suggestion').forEach((button) => {
    button.addEventListener('click', () => {
      const input = root.querySelector('[data-ai-question]');

      if (input) {
        input.value = button.textContent.trim();
        input.focus();
      }
    });
  });

  /*
    MORE RECIPE FILTERS
  */
  root.querySelectorAll('.ib-more-filters button').forEach((button) => {
    button.addEventListener('click', () => {
      root.querySelectorAll('.ib-more-filters button').forEach((item) => {
        item.classList.remove('is-active');
      });

      button.classList.add('is-active');
    });
  });

  /*
    INFO BLOCK ON SCORES
  */
  document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('ib-score-modal');
    const triggers = document.querySelectorAll('.ib-score-modal-trigger');

    if (!modal || !triggers.length) return;

    const closeButtons = modal.querySelectorAll('[data-score-modal-close]');
    const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    let previousFocus = null;

    function openModal(trigger) {
      previousFocus = trigger || document.activeElement;

      modal.hidden = false;
      document.body.classList.add('ib-score-modal-open');

      const closeButton = modal.querySelector('.ib-score-modal__close');
      if (closeButton) closeButton.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('ib-score-modal-open');

      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openModal(trigger);
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;

      if (event.key === 'Escape') {
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusableElements = modal.querySelectorAll(focusableSelector);
      if (!focusableElements.length) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    });
  });
})();